// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"123":"icons","293":"itamat","333":"party","353":"contact","389":"404","539":"misc","594":"about","609":"faq"}[chunkId] + "." + {"123":"ffb8478a","293":"8b1e0e9d","333":"9dc9c0ea","353":"66a267d5","389":"2dcfa09f","539":"6815e63c","594":"ac75685c","609":"ef24ea04"}[chunkId] + ".js";
};